import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Avatar,
  IconButton,
  Switch,
  FormControlLabel,
  Chip,
  Fab,
  Card,
  CardContent,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress
} from '@mui/material';
import {
  Close as CloseIcon,
  Home as HomeIcon,
  Event as EventIcon,
  Announcement as AnnouncementIcon,
  HowToReg as HowToRegIcon,
  MonetizationOn as MonetizationOnIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import axios from 'axios';
import logo from '../assets/logo.png';

const MemberDashboard = () => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };
  const [activeSection, setActiveSection] = useState('dashboard');
  const [events, setEvents] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [openDonateDialog, setOpenDonateDialog] = useState(false);
  const [donationForm, setDonationForm] = useState({
    amount: '',
    description: '',
    payment_method: 'upi',
    reference_number: '',
    notes: ''
  });
  const [donationError, setDonationError] = useState('');
  const [donationStats, setDonationStats] = useState({
    totalDonated: 0,
    verifiedDonations: 0,
    pendingDonations: 0,
    rejectedDonations: 0
  });
  const [profile, setProfile] = useState({
    full_name: '',
    dob: '',
    college_roll_number: '',
    ikshana_id: '',
    designation: '',
    department: '',
    section: '',
    profile_picture: ''
  });
  const [editProfile, setEditProfile] = useState(false);
  const [tempProfile, setTempProfile] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [itemType, setItemType] = useState(''); // 'announcement' or 'event'
  const [showPastEvents, setShowPastEvents] = useState(false);
  const [countdowns, setCountdowns] = useState({});
  const [openProfileDialog, setOpenProfileDialog] = useState(false);

  const styles = {
    container: {
      display: 'flex',
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      flexDirection: { xs: 'column', md: 'row' },
    },
    sidebar: {
      width: { xs: '100%', md: '240px' },
      backgroundColor: '#ffffff',
      borderRight: { xs: 'none', md: '1px solid #d2d2d7' },
      borderBottom: { xs: '1px solid #d2d2d7', md: 'none' },
      padding: { xs: '12px', md: '24px' },
      display: 'flex',
      flexDirection: { xs: 'row', md: 'column' },
      position: { xs: 'relative', md: 'fixed' },
      top: 0,
      left: 0,
      bottom: { xs: 'auto', md: 0 },
      overflowY: 'auto',
      overflowX: { xs: 'auto', md: 'hidden' },
      boxShadow: 'none',
      zIndex: 1000,
    },
    sidebarItem: {
      display: 'flex',
      alignItems: 'center',
      padding: { xs: '8px', md: '12px 16px' },
      borderRadius: '8px',
      marginBottom: { xs: 0, md: '8px' },
      marginRight: { xs: '8px', md: 0 },
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      color: '#1d1d1f',
      whiteSpace: { xs: 'nowrap', md: 'normal' },
      fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '15px',
      '&:hover': {
        backgroundColor: '#f5f5f7',
      },
      '&.active': {
        backgroundColor: '#f5f5f7',
        color: '#0066cc',
        fontWeight: 500,
      },
    },
    mainContent: {
      marginLeft: { xs: 0, md: '260px' },
      flex: 1,
      padding: { xs: '16px', md: '24px 32px' },
      width: { xs: '100%', md: 'calc(100% - 260px)' },
      boxSizing: 'border-box',
      marginTop: { xs: '16px', md: 0 },
    },
    header: {
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #d2d2d7',
      padding: { xs: '16px', md: '20px' },
      marginBottom: { xs: '16px', md: '24px' },
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: { xs: '12px', sm: 0 },
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    section: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #d2d2d7',
      padding: { xs: '16px', md: '24px' },
      marginBottom: { xs: '16px', md: '24px' },
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
      overflowX: 'auto',
    },
    card: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #d2d2d7',
      padding: '20px',
      marginBottom: '16px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      },
    },
    statCard: {
      padding: '24px',
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      border: '1px solid #d2d2d7',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    },
    table: {
      '& .MuiTableCell-head': {
        fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        color: '#86868b',
        borderBottom: '1px solid #d2d2d7',
        backgroundColor: '#f5f5f7',
      },
      '& .MuiTableCell-body': {
        fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        fontSize: '15px',
        color: '#1d1d1f',
        borderBottom: '1px solid #d2d2d7',
      },
      '& .MuiTableRow-root:hover': {
        backgroundColor: '#f5f5f7',
      },
    },
    button: {
      fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '15px',
      fontWeight: 500,
      borderRadius: '8px',
      textTransform: 'none',
      padding: '8px 16px',
      backgroundColor: '#0066cc',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#0055b3',
      },
    },
    secondaryButton: {
      fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '15px',
      fontWeight: 500,
      borderRadius: '8px',
      textTransform: 'none',
      padding: '8px 16px',
      backgroundColor: '#f5f5f7',
      color: '#1d1d1f',
      '&:hover': {
        backgroundColor: '#e5e5e5',
      },
    },
    dialog: {
      '& .MuiDialog-paper': {
        borderRadius: '12px',
        padding: '24px',
      },
      '& .MuiDialogTitle-root': {
        fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        fontSize: '20px',
        fontWeight: 600,
        letterSpacing: '-0.015em',
        padding: 0,
        marginBottom: '16px',
      },
      '& .MuiDialogContent-root': {
        padding: '0',
      },
      '& .MuiDialogActions-root': {
        padding: '16px 0 0 0',
      },
    },
    textField: {
      '& .MuiInputLabel-root': {
        fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        fontSize: '15px',
        color: '#86868b',
      },
      '& .MuiOutlinedInput-root': {
        fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        fontSize: '15px',
        borderRadius: '8px',
        '& fieldset': {
          borderColor: '#d2d2d7',
        },
        '&:hover fieldset': {
          borderColor: '#0066cc',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#0066cc',
          boxShadow: '0 0 0 2px rgba(0, 102, 204, 0.1)',
        },
      },
    },
    chip: {
      fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '13px',
      fontWeight: 500,
      borderRadius: '6px',
    },
    title: {
      fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '24px',
      fontWeight: 600,
      letterSpacing: '-0.015em',
      color: '#1d1d1f',
      marginBottom: '16px',
    },
    subtitle: {
      fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
      fontSize: '15px',
      color: '#86868b',
      marginBottom: '24px',
    },
    fab: {
      position: 'fixed',
      bottom: { xs: '16px', md: '24px' },
      right: { xs: '16px', md: '24px' },
      backgroundColor: '#1a237e',
      color: 'white',
      zIndex: 1100,
      '&:hover': {
        backgroundColor: '#283593',
      },
    },
    userProfile: {
      marginTop: 'auto',
      padding: '16px',
      borderTop: '1px solid rgba(255, 255, 255, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',  // Align items to the start
    },
    logoutButton: {
      marginTop: '8px',
      padding: '12px 16px',
      borderRadius: '12px',
      backgroundColor: '#f44336',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#d32f2f',
      },
      gap: '12px',
      position: 'sticky',
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
    },
    profilePicture: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      border: '2px solid #1a237e',
    },
    sectionHeader: {
      padding: { xs: '16px', md: '24px' },
      marginBottom: { xs: '24px', md: '32px' },
      borderBottom: '1px solid #d2d2d7',
      '& h5': {
        fontSize: '24px',
        fontWeight: 600,
        color: '#1d1d1f',
        fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        letterSpacing: '-0.015em',
        margin: 0
      }
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      console.log('Fetching member data...');

      // Fetch events
      const eventsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/events`,
        config
      );
      console.log('Fetched events:', eventsResponse.data);
      setEvents(eventsResponse.data);

      // Fetch announcements
      const announcementsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/announcements`,
        config
      );
      console.log('Fetched announcements:', announcementsResponse.data);
      setAnnouncements(announcementsResponse.data);

      // Fetch attendance
      const attendanceResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/attendance`,
        config
      );
      console.log('Fetched attendance:', attendanceResponse.data);
      setAttendance(attendanceResponse.data);

      // Fetch donations
      const donationsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/donations/my-donations`,
        config
      );
      setDonations(donationsResponse.data.donations);
      setDonationStats(donationsResponse.data.statistics);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(error.response?.data?.message || 'Failed to fetch data. Please try again.');
      setLoading(false);
      if (error.response?.status === 401) {
        handleLogout();
      }
    }
  };

  const fetchProfile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/profile`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }
      );
      setProfile(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
      setError(error.response?.data?.message || 'Failed to fetch profile');
    }
  };

  const handleDonateClick = () => {
    setDonationForm({
      amount: '',
      description: '',
      payment_method: 'upi',
      reference_number: '',
      notes: ''
    });
    setDonationError('');
    setOpenDonateDialog(true);
  };

  const handleDonationSubmit = async () => {
    try {
      setDonationError('');
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/donations`,
        donationForm,
        config
      );

      setOpenDonateDialog(false);
      fetchData(); // Refresh the donations list
      setSuccessMessage('Donation submitted successfully');
    } catch (error) {
      console.error('Error submitting donation:', error);
      setDonationError(error.response?.data?.message || 'Failed to submit donation. Please try again.');
    }
  };

  const handleSaveProfile = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/profile`,
        tempProfile,
        config
      );

      setProfile(response.data.data);
      setEditProfile(false);
      setSuccessMessage('Profile updated successfully');
    } catch (error) {
      console.error('Error updating profile:', error);
      setError(error.response?.data?.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  const handleEditProfile = () => {
    setTempProfile({
      full_name: profile.full_name || '',
      dob: profile.dob || '',
      college_roll_number: profile.college_roll_number || '',
      designation: profile.designation || '',
      department: profile.department || '',
      section: profile.section || ''
    });
    setEditProfile(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTempProfile(prev => ({
      ...prev,
      [name]: value === '' ? null : value
    }));
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedImage(event.target.files[0]);
    }
  };

  const handleDonationChange = (e) => {
    const { name, value } = e.target;
    setDonationForm(prev => ({
      ...prev,
      [name]: value === '' ? null : value
    }));
  };

  const handleItemClick = (item, type) => {
    setSelectedItem(item);
    setItemType(type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedItem(null);
    setItemType('');
  };

  const handleProfileClick = () => {
    setOpenProfileDialog(true);
  };

  const handleCloseProfile = () => {
    setOpenProfileDialog(false);
  };

  const renderDetailDialog = () => {
    if (!selectedItem) return null;

    return (
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              {itemType === 'announcement' ? 'Announcement Details' : 'Event Details'}
            </Typography>
            <IconButton onClick={handleCloseDialog} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {itemType === 'announcement' ? (
            <>
              <Typography variant="h6" gutterBottom>
                {selectedItem.title}
              </Typography>
              <Typography variant="body1" paragraph>
                {selectedItem.content}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Posted on: {new Date(selectedItem.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                {selectedItem.title}
              </Typography>
              <Typography variant="body1" paragraph>
                {selectedItem.description}
              </Typography>
              <Typography variant="subtitle2" gutterBottom>
                Date: {new Date(selectedItem.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </Typography>
              <Typography variant="subtitle2" gutterBottom>
                Time: {selectedItem.time}
              </Typography>
              <Typography variant="subtitle2" gutterBottom>
                Location: {selectedItem.location}
              </Typography>
              {selectedItem.additional_info && (
                <Typography variant="body2" sx={{ mt: 2 }}>
                  Additional Information: {selectedItem.additional_info}
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderDonateDialog = () => (
    <Dialog open={openDonateDialog} onClose={() => setOpenDonateDialog(false)} maxWidth="md" fullWidth>
      <DialogTitle>Make a Donation</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {/* Payment Details Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Payment Details
              </Typography>
              <Paper sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
                <Typography variant="subtitle1" gutterBottom>
                  Bank Details:
                </Typography>
                <Typography variant="body2">
                  Account Name: Ikshana Foundation<br />
                  Account Number: 1234567890<br />
                  IFSC Code: SBIN0123456<br />
                  Bank: State Bank of India<br />
                  Branch: Hyderabad Main Branch
                </Typography>
              </Paper>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="subtitle1" gutterBottom>
                  UPI QR Code
                </Typography>
                <Box
                  component="img"
                  src="images/upi-qr.png"
                  alt="UPI QR Code"
                  sx={{
                    width: '200px',
                    height: '200px',
                    mb: 1,
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    p: 1,
                    objectFit: 'contain'
                  }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  UPI ID: ikshana@upi
                </Typography>
              </Paper>
            </Box>
          </Grid>

          {/* Donation Form Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Donation Details
              </Typography>
              {donationError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {donationError}
                </Alert>
              )}
              <TextField
                fullWidth
                label="Amount"
                type="number"
                name="amount"
                value={donationForm.amount}
                onChange={handleDonationChange}
                required
                sx={{ mb: 2 }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Payment Method</InputLabel>
                <Select
                  name="payment_method"
                  value={donationForm.payment_method}
                  onChange={handleDonationChange}
                  required
                >
                  <MenuItem value="upi">UPI</MenuItem>
                  <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label="Reference Number"
                name="reference_number"
                value={donationForm.reference_number}
                onChange={handleDonationChange}
                required
                sx={{ mb: 2 }}
                helperText="Enter UPI reference number or bank transaction ID"
              />
              <TextField
                fullWidth
                label="Notes"
                name="notes"
                value={donationForm.notes}
                onChange={handleDonationChange}
                multiline
                rows={3}
                sx={{ mb: 2 }}
                helperText="Any additional information about your donation"
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDonateDialog(false)}>Cancel</Button>
        <Button 
          onClick={handleDonationSubmit}
          variant="contained" 
          color="primary"
          disabled={!donationForm.amount || !donationForm.reference_number || !donationForm.payment_method}
        >
          Submit Donation
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderProfileDialog = () => {
    return (
      <Dialog
        open={openProfileDialog}
        onClose={handleCloseProfile}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
            padding: '20px',
          }
        }}
      >
        <DialogTitle sx={{ textAlign: 'center', position: 'relative', pb: 3 }}>
          <IconButton
            onClick={handleCloseProfile}
            sx={{
              position: 'absolute',
              right: 0,
              top: 0,
              color: '#1a237e',
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
            <Avatar
              src={profile.profile_picture}
              sx={{
                width: 120,
                height: 120,
                border: '4px solid #1a237e',
                boxShadow: '0 4px 14px 0 rgba(26, 35, 126, 0.2)',
                mb: 2
              }}
            />
            <Typography variant="h5" sx={{ color: '#1a237e', fontWeight: 600 }}>
              {profile.full_name}
            </Typography>
            <Chip
              label={profile.designation}
              sx={{
                mt: 1,
                backgroundColor: '#1a237e',
                color: 'white',
                borderRadius: '12px',
                '& .MuiChip-label': { px: 2 }
              }}
            />
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Ikshana ID
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {profile.ikshana_id}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Date of Birth
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {new Date(profile.dob).toLocaleDateString('en-IN', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Department
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {profile.department}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Section
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {profile.section}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  College Roll Number
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {profile.college_roll_number}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  const renderEvents = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Set to start of day for fair comparison
    
    const upcomingEvents = events
      .filter(event => {
        const eventDate = new Date(event.date);
        eventDate.setHours(0, 0, 0, 0);
        return eventDate >= now;
      })
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    // Take only the first upcoming event
    const nextEvent = upcomingEvents[0];

    return (
      <Grid item xs={12} md={6}>
        <Paper 
          sx={{ 
            p: 3, 
            height: '100%',
            display: 'flex', 
            flexDirection: 'column',
            borderRadius: 2,
            boxShadow: 3
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6">Next Event</Typography>
            <Button 
              color="primary" 
              onClick={() => navigate('/events')}
              endIcon={<EventIcon />}
              size="small"
            >
              View All
            </Button>
          </Box>
          {nextEvent ? (
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                {nextEvent.title}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{
                  mb: 2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {nextEvent.description}
              </Typography>
              <Box sx={{ mt: 'auto' }}>
                <Typography variant="subtitle2" color="primary.main" gutterBottom>
                  <strong>Date:</strong> {new Date(nextEvent.date).toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </Typography>
                {nextEvent.time && (
                  <Typography variant="subtitle2" color="primary.main" gutterBottom>
                    <strong>Time:</strong> {nextEvent.time}
                  </Typography>
                )}
                {nextEvent.location && (
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <strong>Location:</strong> {nextEvent.location}
                  </Typography>
                )}
                {countdowns[nextEvent.id] && (
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      mt: 2,
                      p: 2,
                      backgroundColor: 'primary.main',
                      color: 'white',
                      borderRadius: 2,
                      textAlign: 'center'
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      Time Remaining
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {countdowns[nextEvent.id].days}
                        </Typography>
                        <Typography variant="caption">Days</Typography>
                      </Box>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {countdowns[nextEvent.id].hours}
                        </Typography>
                        <Typography variant="caption">Hours</Typography>
                      </Box>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {countdowns[nextEvent.id].minutes}
                        </Typography>
                        <Typography variant="caption">Minutes</Typography>
                      </Box>
                    </Box>
                  </Paper>
                )}
              </Box>
            </Box>
          ) : (
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="body1" color="text.secondary">
                No upcoming events scheduled
              </Typography>
            </Box>
          )}
        </Paper>
      </Grid>
    );
  };

  const renderAnnouncements = () => {
    // Get the 2 most recent announcements
    const recentAnnouncements = [...announcements]
      .sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return isNaN(dateB) ? -1 : isNaN(dateA) ? 1 : dateB - dateA;
      })
      .slice(0, 2);

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date)) {
        return 'Date not available';
      }
      try {
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        return 'Date not available';
      }
    };

    return (
      <Grid item xs={12} md={6}>
        <Paper 
          sx={{ 
            p: 3, 
            height: '100%',
            display: 'flex', 
            flexDirection: 'column',
            borderRadius: 2,
            boxShadow: 3
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6">Recent Announcements</Typography>
            <Button 
              color="primary" 
              onClick={() => navigate('/announcements')}
              endIcon={<AnnouncementIcon />}
              size="small"
            >
              View All
            </Button>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            {recentAnnouncements.length > 0 ? (
              <Grid container spacing={2}>
                {recentAnnouncements.map((announcement) => (
                  <Grid item xs={12} key={announcement.id}>
                    <Paper 
                      sx={{ 
                        p: 2,
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        '&:hover': {
                          boxShadow: 2,
                          transform: 'translateY(-2px)'
                        }
                      }}
                      onClick={() => handleItemClick(announcement, 'announcement')}
                    >
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {announcement.title}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{
                          mb: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                        }}
                      >
                        {announcement.content}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Posted on: {formatDate(announcement.created_at)}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Typography variant="body1" color="text.secondary">
                  No announcements available
                </Typography>
              </Box>
            )}
          </Box>
        </Paper>
      </Grid>
    );
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'attendance':
        return (
          <Box sx={{ p: 0 }}>
            <Box sx={styles.sectionHeader}>
              <Typography variant="h5">Attendance Records</Typography>
            </Box>
            
            {/* Summary Cards */}
            <Box sx={{ px: { xs: '16px', md: '24px' } }}>
              <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    p: 3, 
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.85), rgba(30, 136, 229, 0.75))',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 8px 32px rgba(33, 150, 243, 0.3)',
                    color: 'white'
                  }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Total Classes</Typography>
                    <Typography variant="h3">{attendance.length}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    p: 3, 
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.85), rgba(69, 160, 73, 0.75))',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
                    color: 'white'
                  }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Attendance Rate</Typography>
                    <Typography variant="h3">
                      {attendance.length > 0
                        ? `${((attendance.filter(a => a.status === 'present').length / attendance.length) * 100).toFixed(1)}%`
                        : '0%'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* Attendance Table */}
            <Box sx={{ 
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden'
            }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>Notes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendance.map((record, index) => (
                      <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'rgba(0, 0, 0, 0.02)' } }}>
                        <TableCell>
                          {new Date(record.date).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={record.status}
                            color={record.status === 'present' ? 'success' : 'error'}
                            sx={{ 
                              fontWeight: 500,
                              '& .MuiChip-label': { px: 2 }
                            }}
                          />
                        </TableCell>
                        <TableCell>{record.notes || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        );

      case 'donations':
        return (
          <Box sx={{ p: 0 }}>
            <Box sx={styles.sectionHeader}>
              <Typography variant="h5">Donation Statistics</Typography>
            </Box>
            
            <Box sx={{ px: { xs: '16px', md: '24px' } }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={3}>
                  <Box sx={{ ...styles.statCard, background: 'linear-gradient(135deg, rgba(4, 175, 80, 0.85), rgba(69, 160, 73, 0.75))', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', border: '1px solid rgba(255, 255, 255, 0.2)', height: '130px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: '16px', p: 3, boxShadow: '0 8px 32px rgba(4, 175, 80, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(4, 175, 80, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)', background: 'linear-gradient(135deg, rgba(4, 175, 80, 0.9), rgba(69, 160, 73, 0.8))' } }}>
                    <Typography variant="subtitle2" sx={{ color: 'white' }}>Total Donated</Typography>
                    <Typography variant="h4" sx={{ color: 'white' }}>₹{donationStats.totalDonated}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Box sx={{ ...styles.statCard, background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.85), rgba(30, 136, 229, 0.75))', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', border: '1px solid rgba(255, 255, 255, 0.2)', height: '130px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: '16px', p: 3, boxShadow: '0 8px 32px rgba(33, 150, 243, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(33, 150, 243, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)', background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.9), rgba(30, 136, 229, 0.8))' } }}>
                    <Typography variant="subtitle2" sx={{ color: 'white' }}>Verified Donations</Typography>
                    <Typography variant="h4" sx={{ color: 'white' }}>{donationStats.verifiedDonations}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Box sx={{ ...styles.statCard, background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.85), rgba(255, 160, 0, 0.75))', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', border: '1px solid rgba(255, 255, 255, 0.2)', height: '130px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: '16px', p: 3, boxShadow: '0 8px 32px rgba(255, 193, 7, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(255, 193, 7, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)', background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.9), rgba(255, 160, 0, 0.8))' } }}>
                    <Typography variant="subtitle2" sx={{ color: 'white' }}>Pending</Typography>
                    <Typography variant="h4" sx={{ color: 'white' }}>{donationStats.pendingDonations}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Box sx={{ ...styles.statCard, background: 'linear-gradient(135deg, rgba(244, 67, 54, 0.85), rgba(229, 57, 53, 0.75))', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', border: '1px solid rgba(255, 255, 255, 0.2)', height: '130px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: '16px', p: 3, boxShadow: '0 8px 32px rgba(244, 67, 54, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(244, 67, 54, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)', background: 'linear-gradient(135deg, rgba(244, 67, 54, 0.9), rgba(229, 57, 53, 0.8))' } }}>
                    <Typography variant="subtitle2" sx={{ color: 'white' }}>Rejected</Typography>
                    <Typography variant="h4" sx={{ color: 'white' }}>{donationStats.rejectedDonations}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <TableContainer component={Paper} sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {donations.map((donation, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {donation.date 
                          ? new Date(donation.date).toLocaleDateString('en-IN', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })
                          : new Date().toLocaleDateString('en-IN', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })
                        }
                      </TableCell>
                      <TableCell>₹{donation.amount}</TableCell>
                      <TableCell>{donation.description}</TableCell>
                      <TableCell>
                        <Chip
                          label={donation.status}
                          color={
                            donation.status === 'verified'
                              ? 'success'
                              : donation.status === 'pending'
                              ? 'warning'
                              : 'error'
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );

      case 'events':
        return (
          <Box sx={{ p: 0 }}>
            <Box sx={styles.sectionHeader}>
              <Typography variant="h5">Events</Typography>
            </Box>
            
            <Box sx={{ px: { xs: '16px', md: '24px' } }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showPastEvents}
                      onChange={(e) => setShowPastEvents(e.target.checked)}
                    />
                  }
                  label="Show Past Events"
                />
              </Box>
              <Grid container spacing={3}>
                {events
                  .filter(event => {
                    const eventDate = new Date(event.date);
                    const now = new Date();
                    return showPastEvents ? true : eventDate >= now;
                  })
                  .map((event, index) => (
                    <Grid item xs={12} md={6} key={index}>
                      <Card sx={styles.card}>
                        <CardContent>
                          <Typography variant="h6">{event.title}</Typography>
                          <Typography variant="body2" color="text.secondary" gutterBottom>
                            {new Date(event.date).toLocaleDateString()}
                          </Typography>
                          <Typography variant="body1">{event.description}</Typography>
                          <Box sx={{ mt: 2 }}>
                            <Chip
                              label={new Date(event.date) > new Date() ? 'Upcoming' : 'Past'}
                              color={new Date(event.date) > new Date() ? 'primary' : 'default'}
                            />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Box>
        );

      case 'announcements':
        return (
          <Box sx={{ p: 0 }}>
            <Box sx={styles.sectionHeader}>
              <Typography variant="h5">Announcements</Typography>
            </Box>
            
            <Box sx={{ px: { xs: '16px', md: '24px' } }}>
              {announcements.map((announcement, index) => (
                <Card sx={styles.card} key={index}>
                  <CardContent>
                    <Typography variant="h6">{announcement.title}</Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {new Date(announcement.date).toLocaleDateString()}
                    </Typography>
                    <Typography variant="body1">{announcement.content}</Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>
        );

      default:
        return (
          <Box>
            <Box sx={styles.sectionHeader}>
              <Typography variant="h5">Dashboard</Typography>
            </Box>
            
            <Box sx={{ px: { xs: '16px', md: '24px' } }}>
              <Grid container spacing={3} sx={{ mb: 3, height: '100%' }}>
                {/* Total Donated */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    ...styles.statCard, 
                    background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.85), rgba(69, 160, 73, 0.75))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    height: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '16px',
                    p: 3,
                    boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(76, 175, 80, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)',
                      background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.9), rgba(69, 160, 73, 0.8))',
                    }
                  }}>
                    <MonetizationOnIcon sx={{ fontSize: 56, mb: 2, color: 'rgba(255, 255, 255, 0.95)' }} />
                    <Typography variant="h5" sx={{ color: 'rgba(255, 255, 255, 0.95)', mb: 2, fontWeight: 500 }}>
                      Total Donated
                    </Typography>
                    <Typography variant="h3" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 600 }}>
                      ₹{donationStats.totalDonated}
                    </Typography>
                  </Box>
                </Grid>

                {/* Next Event */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    ...styles.statCard, 
                    background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.85), rgba(30, 136, 229, 0.75))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    height: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '16px',
                    p: 3,
                    boxShadow: '0 8px 32px rgba(33, 150, 243, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(33, 150, 243, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)',
                      background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.9), rgba(30, 136, 229, 0.8))',
                    }
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <EventIcon sx={{ fontSize: 56, color: 'rgba(255, 255, 255, 0.95)', mr: 2 }} />
                      <Typography variant="h5" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500 }}>
                        Next Event
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {events.length > 0 ? (
                        <>
                          <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.95)', mb: 1 }}>
                            {events[0].title}
                          </Typography>
                          <Typography variant="h4" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
                            {new Date(events[0].date).toLocaleDateString('en-IN', {
                              month: 'short',
                              day: 'numeric'
                            })}
                          </Typography>
                        </>
                      ) : (
                        <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
                          No upcoming events
                        </Typography>
                      )}
                    </Box>
                    <Button
                      variant="text"
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.95)',
                        mt: 2,
                        fontSize: '1rem',
                        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                      }}
                      onClick={() => setActiveSection('events')}
                    >
                      View All Events
                    </Button>
                  </Box>
                </Grid>

                {/* Recent Announcement */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    ...styles.statCard, 
                    background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.85), rgba(255, 160, 0, 0.75))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    height: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '16px',
                    p: 3,
                    boxShadow: '0 8px 32px rgba(255, 193, 7, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(255, 193, 7, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)',
                      background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.9), rgba(255, 160, 0, 0.8))',
                    }
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <AnnouncementIcon sx={{ fontSize: 56, color: 'rgba(255, 255, 255, 0.95)', mr: 2 }} />
                      <Typography variant="h5" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500 }}>
                        Recent Announcement
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {announcements.length > 0 ? (
                        <Typography 
                          variant="h6" 
                          sx={{ 
                            color: 'rgba(255, 255, 255, 0.95)',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical'
                          }}
                        >
                          {announcements[0].title}
                        </Typography>
                      ) : (
                        <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
                          No announcements
                        </Typography>
                      )}
                    </Box>
                    <Button
                      variant="text"
                      sx={{ 
                        color: 'rgba(255, 255, 255, 0.95)',
                        mt: 2,
                        fontSize: '1rem',
                        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                      }}
                      onClick={() => setActiveSection('announcements')}
                    >
                      View All Announcements
                    </Button>
                  </Box>
                </Grid>

                {/* Attendance Rate */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ 
                    ...styles.statCard, 
                    background: 'linear-gradient(135deg, rgba(244, 67, 54, 0.85), rgba(229, 57, 53, 0.75))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    height: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '16px',
                    p: 3,
                    boxShadow: '0 8px 32px rgba(244, 67, 54, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(244, 67, 54, 0.4), 0 8px 12px rgba(0, 0, 0, 0.15)',
                      background: 'linear-gradient(135deg, rgba(244, 67, 54, 0.9), rgba(229, 57, 53, 0.8))',
                    }
                  }}>
                    <HowToRegIcon sx={{ fontSize: 56, mb: 2, color: 'rgba(255, 255, 255, 0.95)' }} />
                    <Typography variant="h5" sx={{ color: 'rgba(255, 255, 255, 0.95)', mb: 2, fontWeight: 500 }}>
                      Attendance Rate
                    </Typography>
                    <Typography variant="h3" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 600 }}>
                      {attendance.length > 0
                        ? `${((attendance.filter(a => a.status === 'present').length / attendance.length) * 100).toFixed(1)}%`
                        : '0%'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        );
    }
  };

  // Update countdowns every second
  useEffect(() => {
    const calculateCountdown = (eventDate) => {
      const now = new Date();
      const eventTime = new Date(eventDate);
      const diff = eventTime - now;

      if (diff <= 0) return null;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      return { days, hours, minutes };
    };

    const timer = setInterval(() => {
      const newCountdowns = {};
      events.forEach(event => {
        const countdown = calculateCountdown(event.date);
        if (countdown) {
          newCountdowns[event.id] = countdown;
        }
      });
      setCountdowns(newCountdowns);
    }, 1000);

    return () => clearInterval(timer);
  }, [events]);

  useEffect(() => {
    fetchData();
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth={false} disableGutters sx={styles.container}>
      <Box sx={styles.sidebar}>
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <img 
            src={logo}
            alt="Ikshana Logo"
            style={{ 
              width: '40px',
              height: '40px',
              objectFit: 'contain',
              display: 'block'
            }}
          />
          <Typography variant="h6" sx={{ 
            color: 'primary.main', 
            fontWeight: 600,
            fontSize: '1.25rem',
            letterSpacing: '0.5px'
          }}>
            Ikshana Portal
          </Typography>
        </Box>

        <Box
          sx={{
            ...styles.sidebarItem,
            backgroundColor: activeSection === 'dashboard' ? 'rgba(26, 35, 126, 0.05)' : 'transparent',
          }}
          onClick={() => setActiveSection('dashboard')}
        >
          <HomeIcon sx={{ mr: 2 }} />
          <Typography>Dashboard</Typography>
        </Box>

        <Box
          sx={{
            ...styles.sidebarItem,
            backgroundColor: activeSection === 'attendance' ? 'rgba(26, 35, 126, 0.05)' : 'transparent',
          }}
          onClick={() => setActiveSection('attendance')}
        >
          <HowToRegIcon sx={{ mr: 2 }} />
          <Typography>Attendance</Typography>
        </Box>

        <Box
          sx={{
            ...styles.sidebarItem,
            backgroundColor: activeSection === 'donations' ? 'rgba(26, 35, 126, 0.05)' : 'transparent',
          }}
          onClick={() => setActiveSection('donations')}
        >
          <MonetizationOnIcon sx={{ mr: 2 }} />
          <Typography>Donations</Typography>
        </Box>

        <Box
          sx={{
            ...styles.sidebarItem,
            backgroundColor: activeSection === 'events' ? 'rgba(26, 35, 126, 0.05)' : 'transparent',
          }}
          onClick={() => setActiveSection('events')}
        >
          <EventIcon sx={{ mr: 2 }} />
          <Typography>Events</Typography>
        </Box>

        <Box
          sx={{
            ...styles.sidebarItem,
            backgroundColor: activeSection === 'announcements' ? 'rgba(26, 35, 126, 0.05)' : 'transparent',
          }}
          onClick={() => setActiveSection('announcements')}
        >
          <AnnouncementIcon sx={{ mr: 2 }} />
          <Typography>Announcements</Typography>
        </Box>

        <Box sx={{ mt: 'auto', mb: 2 }}>
          {/* User Profile */}
          <Box 
            sx={{
              ...styles.userProfile,
              pl: 1,  // Add left padding to move content slightly left
              gap: 2   // Use gap for consistent spacing between items
            }}
            onClick={handleProfileClick}
            style={{ cursor: 'pointer', borderBottom: 'none', marginTop: 0 }}
          >
            <Avatar src={profile.profile_picture} sx={styles.profilePicture} />
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1a237e' }}>
                {profile.full_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {profile.designation}
              </Typography>
            </Box>
          </Box>

          {/* Logout Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
            sx={{
              mt: 2,
              backgroundColor: '#f44336',
              color: 'white',
              '&:hover': {
                backgroundColor: '#d32f2f'
              },
              textTransform: 'none',
              borderRadius: '12px',
              py: 1
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>

      <Box sx={styles.mainContent}>
        {renderContent()}
      </Box>

      {/* Floating Action Button for Donations */}
      <Fab
        color="primary"
        aria-label="add donation"
        onClick={handleDonateClick}
        sx={styles.fab}
      >
        <MonetizationOnIcon />
      </Fab>

      {/* Dialogs */}
      {renderDonateDialog()}
      {renderDetailDialog()}
      {renderProfileDialog()}
    </Container>
  );
};

export default MemberDashboard;
